import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import ResizeListener from "../../../../utility/ResizeListener";
import RowButtons from "../../../../utility/RowButtons";
import { CustomInput } from "../../../components/customInput/CustomInput";
import { BLACK_COLOR, WHITE_COLOR } from "../../../resources/colorsManager";
import { SUCCESS } from "../../../resources/constantsManager";

function AddAccountModal({ onClose, customerHashId, onSuccess }) {
  const { width, height } = ResizeListener();

  // const [accountFromRedux, setAllAccounts] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIFSCCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    minWidth: 220,
    maxWidth: 450,
    marginRight: 20,
  };

  const onClickAddAccount = (accountNumber, customerHashId, ifscCode) => {
    setLoading(true);
    ApiRequestPost.addCustomerBankAccount({
      accountNumber,
      customerHashId,
      ifscCode,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
          onClose();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        borderRadius: 7,
        width: width * 0.35,
        height: "100%",
        alignItems: "center",
        maxHeight: height * 0.65,
        paddingBottom: 0,
      }}
    >
      <div>
        <p
          style={{
            color: BLACK_COLOR,
            fontWeight: "500",
            fontFamily: "Roboto",
          }}
        >
          Authorised Accounts
        </p>
      </div>

      <div
        style={{
          overflow: "auto",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: "15px 10px",
            marginBottom: 30,
          }}
        >
          <CustomInput
            value={accountNumber}
            onChange={(data) => setAccountNumber(data)}
            inputStyles={{ ...inputStyle }}
            placeholder="Enter Account Number"
            type="input"
            validator="accountNumber"
          />
          <CustomInput
            value={ifscCode}
            onChange={(data) => setIFSCCode(data)}
            inputStyles={{ ...inputStyle }}
            placeholder="Enter IFSC code"
            type="input"
            validator="ifscCode"
          />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          margin: "10px 0px",
        }}
      >
        <RowButtons
          onClick1={() => {
            onClose();
          }}
          onClick2={() => {
            if (ifscCode === "" && accountNumber === "") {
              enqueueSnackbar("Please enter account number and ifsc code", {
                variant: "error",
              });
            } else if (accountNumber === "") {
              enqueueSnackbar("Please enter account number", {
                variant: "error",
              });
            } else if (ifscCode === "") {
              enqueueSnackbar("Please enter ifsc code", {
                variant: "error",
              });
            } else onClickAddAccount(accountNumber, customerHashId, ifscCode);
          }}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            minWidth: 260,
          }}
          buttonStyle1={{
            width: "40%",
            border: "1px solid dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          textStyles1={{
            color: "dodgerblue",
          }}
          buttonStyle2={{
            width: "40%",
            backgroundColor: "dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          buttonTitle2="Add"
          loading2={loading}
        />
      </div>
    </div>
  );
}

export default AddAccountModal;
